import React, { useEffect, useState } from 'react';
import { Table, Button, Row, Col, notification, Select } from 'antd';
import { IoMdDocument } from "react-icons/io";
import { RiFileExcel2Fill } from "react-icons/ri";
import { getCostCenter } from '../services/costCenterService';
import ReactExport from "react-export-excel";

const { Option } = Select;
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function CostCenter(){
  const[dataTableCompleta, setDataTableCompleta] = useState([]);
  const[tableLoading, setTableLoading] = useState(false);
  const[centersLoading, setCentersLoading] = useState(false);
  const[dataCenters, setDataCenters] = useState([]);
  const[selectedCenters, setSelectedCenters] = useState([]);
  const[btnExcelVisible, setBtnExcelVisible] = useState(false);
  

    useEffect(() => {
        async function centers(){
            setCentersLoading(true);
            const request = {
                "CostCenter" : []
            }
            const { data } = await getCostCenter(request);
            setDataCenters(data);
            setCentersLoading(false);
        }
        centers();
        
    },[])

    const msNotification = (type, title, desc) => {
      notification[type]({
        message: title,
        description:
          desc,
      });
    };

    function handleChangeCenters(value) {
        setSelectedCenters(value);
        
    }
   
    const handleClickReport = async () =>{
      setDataTableCompleta([]);
      setBtnExcelVisible(false);
      const request = {
        "CostCenter" : selectedCenters
      }
      setTableLoading(true);
      async function getReport(){
        const { data } = await getCostCenter(request);
        if(data.length === 0){
          msNotification('info', 'Reporte', 'No se encontraron datos con los filtros seleccionados.' );
          setTableLoading(false);
          return false;
        }else{
          setBtnExcelVisible(true);
        }
        
        setDataTableCompleta(data);
        setTableLoading(false);
      }
      getReport();
    }

    const formatNumber = (number)=>{
      let imp = ((number * 100) / 100).toFixed(2);
      return imp;
    }
    

    const rowClassColor = (record, index) => record.value >= 0 ? 'rowGreen' : 'rowRed';

    const columnsComplete = [
      {
        title: 'Centro de costo',
        dataIndex: 'id',
        render: (value) => (value)
      },
      {
        title: 'Importe',
        dataIndex: 'value',
        render: (value) => (`$ ${formatNumber(value)}`)
      },
      
    ];
    
    

    return(
      <div className="mainContainer">
        
        <Row>
            <Col span={24}>
                <h1 className="title">Reporte centros de costo</h1>
                <hr className="hr-title"/>
            </Col>
        </Row>

        <Row className="detailContainer">
          <Col span={20}></Col>
          <Col span={4}>
            <div className="">
              <Button block type="primary" icon={<IoMdDocument/>} onClick={handleClickReport}>
                &nbsp; Generar
              </Button>
            </div>
          </Col>
          <Col span={24}><br /></Col>
          
          <Col span={8}>
            <Select mode="multiple" loading={centersLoading} style={{ width: '100%' }} 
              onChange={handleChangeCenters} 
              placeholder="Centros de costo..."
              maxTagCount='responsive'>
                {dataCenters.map(function(obj){
                    return <Option key={obj.id} value={obj.id}>{obj.id}</Option>
                })}
            </Select>
          </Col>
          <Col span={16}></Col>
          <Col span={24}><br /></Col>
          
          <Col span={24}>
            <Row>
                <Col span={24}><br /></Col>
                <Col span={6} className={"collapse" + (btnExcelVisible ? 'in' : '')}>
                <ExcelFile filename="Reporte-Centros-Costo" element={<Button block type="primary" icon={<RiFileExcel2Fill/>}> Descargar datos</Button>}>
                    <ExcelSheet data={dataTableCompleta} name="Centros de Costo">
                        <ExcelColumn label="Centro costo" value={(col) => col.id}/>
                        <ExcelColumn label="Importe" value={(col) => `$ ${formatNumber(col.value)}`}/>
                        
                    </ExcelSheet>
                    
                </ExcelFile>
                </Col>
                <Col span={24}>
                <br/>
                <Table rowKey="id" dataSource={dataTableCompleta} columns={columnsComplete} 
                    loading={tableLoading} scroll={{ x:'auto' }}
                    rowClassName={rowClassColor}/>
                </Col>
            </Row>
          </Col>
              
        </Row>
      </div>
    );
}

export default CostCenter;



// WEBPACK FOOTER //
// ./src/components/CostCenter.jsx